import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DASHBOARD_PERIODS,
  type DashboardPeriod,
} from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';

export type { DashboardPeriod };

export type DashboardPeriodOption = {
  value: DashboardPeriod;
  label: string;
};

const PERIOD_I18N_KEY: Record<DashboardPeriod, string> = {
  'q1-2026': 'header.period.q1_2026',
  'q2-2026': 'header.period.q2_2026',
  'q3-2026': 'header.period.q3_2026',
  'q4-2026': 'header.period.q4_2026',
  'last-12-months': 'header.period.last12Months',
};

export function useDashboardPeriodOptions(): DashboardPeriodOption[] {
  const { t } = useTranslation('dashboard');

  return useMemo(
    () =>
      DASHBOARD_PERIODS.map((value) => ({
        value,
        label: t(PERIOD_I18N_KEY[value]),
      })),
    [t],
  );
}
